<template>
  <v-card>
    <v-form ref="form" :lazy-validation="true">
      <v-card-title>GODKÄNN GRUNDUTBILDNING (LÄRLING)</v-card-title>
      <v-card-actions>
        <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>
      </v-card-actions>

      <v-card-text class="">
        <p class="mb-8">Denna person har genomfört grundutbildningen som lärling på ett eller flera företag.</p>
        <v-row no-gutters>
          <v-col cols="3">
            <p class="overline">Person</p>
            <p class="mt-n3" v-if="selectedPerson">
              <router-link target="_blank" :to="'/people/' + selectedPerson.id">{{
                selectedPerson | fullName
              }}</router-link>
            </p>
          </v-col>
          <v-col cols="3">
            <p class="overline">Personnummer</p>
            <p class="mt-n3" v-if="selectedPerson">
              {{ selectedPerson.personalNumber | formatPnr }}
            </p>
          </v-col>
          <v-col cols="3">
            <p class="overline">MOBILNUMMER</p>
            <p class="mt-n3" v-if="selectedPerson && selectedPerson.mobilephone">
              <a :href="`tel:${selectedPerson.mobilephone}`"> {{ selectedPerson.mobilephone }}</a>
            </p>
          </v-col>
          <v-col cols="3"
            ><p class="overline">E-POSTADRESS</p>
            <p class="mt-n3" v-if="selectedPerson && selectedPerson.email">
              <a :href="`mailto:${selectedPerson.email}`"> {{ selectedPerson.email }}</a>
            </p>
          </v-col>
          <v-col cols="6" class="mt-1"
            ><p class="overline">Yrke</p>
            <p class="mt-n3" v-if="selectedBook.professionId">
              {{ getProfessionNameById(selectedBook.professionId) }}
            </p>
          </v-col>
          <v-col
            cols="6"
            class="mt-1"
            v-if="
              selectedBook.education &&
              selectedBook.education.educationProfessionOrientations &&
              selectedBook.education.educationProfessionOrientations.length > 0
            "
            ><p class="overline">Maskinslag</p>
            <p class="mt-n3">
              {{
                selectedBook.education.educationProfessionOrientations
                  .map(e => e.professionMachineOrientation.machine.name)
                  .join(', ')
              }}
            </p>
          </v-col>
          <v-col cols="12" class=""
            ><p class="overline">Utbildning</p>
            <p class="mt-n3">Grundutbildning som lärling</p>
          </v-col>
          <v-col cols="12"
            ><p class="overline">E-BOK GODKÄND DATUM</p>
            <div class="d-flex">
              <p class="mt-n3" v-if="selectedBook.approvedByInstructorAt">
                {{ selectedBook.approvedByInstructorAt | date }}
              </p>
            </div>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="6" class="mt-4">
            <p class="overline">HANDLEDARE</p>
            <div
              class="mt-n3"
              v-if="
                selectedBook &&
                selectedBook.apprenticeship &&
                selectedBook.apprenticeship.apprenticeshipInstructors &&
                selectedBook.apprenticeship.apprenticeshipInstructors.length > 0
              "
            >
              <p class="mb-0" v-for="(i, index) in selectedBook.apprenticeship.apprenticeshipInstructors" :key="index">
                <router-link target="_blank" :to="'/people/' + get(i, 'instructor.employed.id', 0)">
                  {{ get(i, 'instructor.employed.firstName', '') }}
                  {{ get(i, 'instructor.employed.lastName', '') }}
                </router-link>
              </p>
            </div>
          </v-col>
          <v-col cols="6" class="mt-4">
            <p class="overline">E-BOKEN GODKÄND AV HANDLEDARE</p>
            <p class="mt-n3" v-if="selectedBook && selectedBook.approvedByInstructor">
              <router-link target="_blank" :to="'/people/' + selectedBook.approvedByInstructor.id">
                {{ selectedBook.approvedByInstructor.firstName || '' }}
                {{ selectedBook.approvedByInstructor.lastName || '' }}
              </router-link>
            </p>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text class="mt-n4">
        <v-row>
          <v-col cols="6"
            ><p class="overline">Godkänd av</p>
            <p
              class="mt-n3"
              v-if="
                selectedBook &&
                selectedBook.education &&
                selectedBook.education.basicEducationCertificate &&
                selectedBook.education.basicEducationCertificate.createdBy
              "
            >
              {{ selectedBook.education.basicEducationCertificate.createdBy | fullName }}
              <span v-if="selectedBook.education.basicEducationCertificate.createdAt"
                >({{ selectedBook.education.basicEducationCertificate.createdAt | date }})</span
              >
            </p>
            <p class="mt-n3 grey-text font-italic" v-else>Ej godkänd.</p>
          </v-col>
          <v-col cols="6"
            ><p class="overline">Bekräftad av</p>
            <p
              class="mt-n3"
              v-if="
                selectedBook &&
                selectedBook.education &&
                selectedBook.education.basicEducationCertificate &&
                selectedBook.education.basicEducationCertificate.approvedBy
              "
            >
              {{ selectedBook.education.basicEducationCertificate.approvedBy | fullName }}
              <span v-if="selectedBook.education.basicEducationCertificate.approvedAt"
                >({{ selectedBook.education.basicEducationCertificate.approvedAt | date }})</span
              >
            </p>
            <p class="mt-n3 grey-text font-italic" v-else>Ej bekräftad.</p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions
        class="justify-space-between mt-n6"
        v-if="
          !(
            selectedBook.education &&
            selectedBook.education.basicEducationCertificate &&
            selectedBook.education.basicEducationCertificate.approvedById &&
            selectedBook.education.basicEducationCertificate.approvedById > 0
          )
        "
      >
        <v-btn
          class=""
          @click="
            $nextTick(() =>
              $router
                .push({
                  name: 'PersonDetail',
                  params: {id: selectedPerson.id},
                  query: {tab: '4'}
                })
                .catch(() => {})
            )
          "
          color="secondary"
        >
          <v-icon>$sl-ebook</v-icon>Visa E-bok
        </v-btn>
        <div class="justify-end">
          <v-btn color="secondary" @click="$emit('close')"> <v-icon>$sl-cancel</v-icon>Avbryt </v-btn>
          <!-- <v-btn outlined @click="deleteBookPause()" :disabled="isButtonsDisabled">
            <v-icon>$sl-delete</v-icon>Radera
          </v-btn> -->
          <v-btn @click="denyModal = true" color="secondary" :disabled="isDisabled || !canUpdate">
            <v-icon>$sl-dislike</v-icon>Neka
          </v-btn>
          <!-- <v-btn @click="update()">
            <v-icon>$sl-check</v-icon>Spara och Godkänn</v-btn
          > -->
          <v-btn @click="approve()" :disabled="isDisabled || !canUpdate"> <v-icon>$sl-check</v-icon>Godkänn</v-btn>
          <v-btn v-if="canUndoApprove" @click="undoApprove()"><v-icon>$sl-cancel</v-icon>Ångra</v-btn>
        </div>
      </v-card-actions>
      <p
        v-if="
          this.selectedBook.education &&
          this.selectedBook.education.basicEducationCertificate &&
          this.selectedBook.education.basicEducationCertificate.createdBy &&
          this.selectedBook.education.basicEducationCertificate.createdBy.id == this.currentUser.id
        "
        class="info-text mt-4 pr-10"
      >
        <i
          ><b>Obs:</b> Du har godkänt denna grundutbildning. Det krävs att en annan regionär kontragodkänner för att den
          ska godkännas fullständigt.</i
        >
      </p>
    </v-form>
    <v-dialog v-model="denyModal" :max-width="590">
      <v-form ref="form" :lazy-validation="true">
        <v-card>
          <v-card-title>NEKA GODKÄNNANDE AV GRUNDUTBILDNING?</v-card-title>
          <v-card-text
            ><p
              v-if="
                !(
                  selectedBook.education &&
                  selectedBook.education.basicEducationCertificate &&
                  selectedBook.education.basicEducationCertificate.createdById &&
                  selectedBook.education.basicEducationCertificate.createdById > 0
                )
              "
            >
              Du är den första regionären som behandlar detta ärende. Om du nekar kommer handledarens godkännande av
              e-boken att tas bort. E-boken kommer därmed gå tillbaka till handledare och lärling för eventuell rättning
              eller komplettering. <br /><br />
              Vi rekommenderar att du tar kontakt med handledare och lärlingen för att besluta om hur ni går vidare.
              <br /><br />
              Handledare som godkänt e-boken:
              <span v-if="selectedBook && selectedBook.approvedByInstructor">
                <router-link target="_blank" :to="'/people/' + selectedBook.approvedByInstructor.id">
                  {{ selectedBook.approvedByInstructor.firstName || '' }}
                  {{ selectedBook.approvedByInstructor.lastName || '' }}
                </router-link>
              </span>
              <br /><br />
              Lärling:
              <span v-if="selectedPerson">
                <router-link target="_blank" :to="'/people/' + selectedPerson.id">{{
                  selectedPerson | fullName
                }}</router-link>
              </span>
              <br /><br />
              När du nekar måste du bifoga en skriftlig motivering till ditt beslut. Motiveringen kommer att skickas
              till handledare och lärling med e-post.
            </p>
            <p v-else>
              Du är den andra regionären som behandlar detta ärende. Om du nekar kommer ärendet återgå till den första
              regionären som godkänt ärendet.
              <br /><br />
              Första regionär som godkänt ärendet:
              <b>
                {{ selectedBook.education.basicEducationCertificate.createdBy.firstName || '' }}
                {{ selectedBook.education.basicEducationCertificate.createdBy.lastName || '' }}
              </b>
              <br /><br />
              Om du vill kan du bifoga en skriftlig motivering till ditt beslut. Motiveringen kommer att skickas med
              e-post till den första regionären som godkänt ärendet.
            </p>
          </v-card-text>
          <v-card-actions>
            <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>
          </v-card-actions>

          <v-card-text class="mt-n2"
            ><v-textarea
              v-if="
                !(
                  selectedBook.education &&
                  selectedBook.education.basicEducationCertificate &&
                  selectedBook.education.basicEducationCertificate.createdById &&
                  selectedBook.education.basicEducationCertificate.createdById > 0
                )
              "
              outlined
              :rules="[rules.required]"
              label="Motivering"
              rows="9"
              v-model="denyMessage"
            ></v-textarea>
            <v-textarea v-else outlined label="Frivillig motivering" rows="9" v-model="denyMessage"></v-textarea>
          </v-card-text>
          <v-card-actions class="d-flex justify-end"
            ><v-btn @click="denyModal = false"> <v-icon>$sl-cancel</v-icon>Avbryt </v-btn>
            <!-- <v-btn outlined @click="deleteBookPause()" :disabled="isButtonsDisabled">
          <v-icon>$sl-delete</v-icon>Radera
        </v-btn> -->
            <v-btn @click="deny()" color="secondary" :disabled="!canUpdate"> <v-icon>$sl-dislike</v-icon>Neka </v-btn></v-card-actions
          >
        </v-card>
      </v-form>
    </v-dialog>
  </v-card>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import API from '@/services/api.js'
import findIndex from 'lodash/findIndex'
import sortBy from 'lodash/sortBy'
import {Regions, RulesMixin, UserRules, CanIDo} from '@/components/mixins'
import DatePicker from '@/components/common/DatePicker'
const SugarDate = require('sugar/date')
import get from 'lodash/get'

// @group Education
// PersonEbookModal component
export default {
  name: 'PersonEbookModal',

  mixins: [Regions, RulesMixin, UserRules, CanIDo],

  components: {
    DatePicker
  },
  props: {
    selectedBook: {
      type: Object,
      // Object or array defaults must be returned from
      // default empty
      default: function () {
        return {}
      }
    }
  },
  data: () => ({
    contactPerson: {},
    denyModal: false,
    denyMessage: ''
  }),
  watch: {
    selectedBook() {
      this.init()
    }
  },
  computed: {
    ...mapGetters('app', ['isLoading']),
    ...mapGetters('currentuser', ['currentUser']),
    ...mapGetters('person', ['selectedPerson']),
    ...mapGetters('basic', [
      'getProfessionById',
      'getProfessionNameById',
      'hasProfessionOrientations',
      'basicMachines',
      'getMachineNameById'
    ]),
    isDisabled() {
      let ret = false
      if (
        this.selectedBook.regionId &&
        this.selectedBook.education &&
        this.selectedBook.education.basicEducationCertificate &&
        this.selectedBook.education.basicEducationCertificate.createdBy &&
        this.selectedBook.education.basicEducationCertificate.createdBy.id
      ) {
        ret = !this.canUserApprove(
          this.selectedBook.regionId,
          this.selectedBook.education.basicEducationCertificate.createdBy.id
        )
      }
      return ret
    },

    canUndoApprove(){
      return this.selectedBook.education &&
        this.selectedBook.education.basicEducationCertificate &&
        this.selectedBook.education.basicEducationCertificate.createdBy &&
        this.selectedBook.education.basicEducationCertificate.createdBy.id === this.currentUser.id &&
        !this.selectedBook.education.basicEducationCertificate.approvedById
    },

    // // @vuese
    // //- Used to return if the currentUser's is regionary and check if it is the same regionary approved the application
    // canApprove() {
    //   // if(this.currentUser.userrole.isAdmin || this.currentUser.userrole.isRegistry)
    //   //   return true

    //   let regionId = -1;

    //   const found = findIndex(this.selectedPerson.books, (o) => {
    //     return o.id === this.bookPauseObj.bookId;
    //   });

    //   if (found > -1) {
    //     if (this.selectedPerson.books[found].regionId) {
    //       regionId = this.selectedPerson.books[found].regionId;
    //     }
    //   }

    //   if (this.bookPauseObj.approvedById == this.currentUser.id) return false;

    //   return (
    //     Boolean(
    //       this.currentUser.userrole.isAdmin || this.currentUser.userrole.isRegistry
    //     ) ||
    //     (this.currentUserRole === "region" &&
    //       this.currentUser.regionIds.includes(regionId))
    //   );
    // },
  },

  asyncComputed: {
    canUpdate(){
      return this.canIDo('education', 'update');
    },
  },

  created() {
    this.init()
  },
  methods: {
    ...mapActions('person', ['updateSelectedPerson', 'setSelectedPerson']),
    get,
    sortBy: sortBy,

    init() {},

    undoApprove(){
      API.denyEducation(this.selectedBook.education.id, { data: {}})
        .then(res => {
          this.$events.fire('showInfo', 'Ansökan nekad.')
          this.$emit('saved')
        })
        .catch(error => {
          console.log('There was an error:', error)
          this.$events.fire('showError', 'Tyvärr gick det inte att neka.')
        })
      this.$emit('close')
    },

    //needs to be approve by 2 persons. Check first if it is approved by a first person.
    approve() {
      let apiMethod = 'issueBook'
      if (
        this.selectedBook.education &&
        this.selectedBook.education.basicEducationCertificate &&
        this.selectedBook.education.basicEducationCertificate.createdBy &&
        this.selectedBook.education.basicEducationCertificate.createdBy.id > 0 &&
        !(
          this.selectedBook.education.basicEducationCertificate.approveBy &&
          this.selectedBook.education.basicEducationCertificate.approveBy.id > 0
        )
      ) {
        apiMethod = 'approveBook'
      }

      API[apiMethod](this.selectedBook.educationId)
        .then(res => {
          //this.setSelectedPerson(this.selectedPerson);
          this.$emit('saved')
          this.$events.fire('showInfo', 'Sparad.')
        })
        .catch(error => {
          console.log('There was an error:', error)
          this.$events.fire('showError', 'Tyvärr gick det inte att spara. ')
        })

      this.$emit('close')
    },

    deny() {
      if (!this.$refs.form.validate()) {
        this.$events.fire('showError', 'Var vänlig och fyll i motiveringen.')
        return
      }
      //console.log(this.selectedBook.education.id, "deny", this.denyMessage);

      this.denyModal = false

      if (this.selectedBook && this.selectedBook.education && this.selectedBook.education.id) {
        API.denyEducation(this.selectedBook.education.id, {
          data: {message: this.denyMessage}
        })
          .then(res => {
            this.$events.fire('showInfo', 'Ansökan nekad.')
            this.$emit('saved')
          })
          .catch(error => {
            console.log('There was an error:', error)
            this.$events.fire('showError', 'Tyvärr gick det inte att neka.')
          })
      }
      this.$emit('close')
    },

    getPerson(id) {
      API.getPerson(id)
        .then(res => {
          this.contactPerson = res.data
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    }
  }
}
</script>
